import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import React from "react";
import styles from "./base-card.module.css";
var BaseCard = function(_param) {
    var children = _param.children, className = _param.className, _element = _param.element, element = _element === void 0 ? "div" : _element, _hasBoxShadow = _param.hasBoxShadow, hasBoxShadow = _hasBoxShadow === void 0 ? false : _hasBoxShadow, _hasBorder = _param.hasBorder, hasBorder = _hasBorder === void 0 ? false : _hasBorder, rest = _object_without_properties(_param, [
        "children",
        "className",
        "element",
        "hasBoxShadow",
        "hasBorder"
    ]);
    var HtmlElement = element;
    var _obj;
    var classes = classNames((_obj = {}, _define_property(_obj, styles.cardBoxShadow, hasBoxShadow), _define_property(_obj, styles.cardBorder, hasBorder), _obj), className, styles.card);
    return /*#__PURE__*/ _jsx(HtmlElement, _object_spread_props(_object_spread({
        className: classes,
        "data-testid": "Atoms/Base-Card"
    }, rest), {
        children: children
    }));
};
export default BaseCard;
